import React from 'react';
import { Edit, useUpdate, useDelete, useRedirect, useNotify, useGetOne } from 'react-admin';
import { useParams } from 'react-router-dom';
import { EstimateBuilder } from '../../components/EstimateBuilder';

export const EstimateEdit = () => {
  const { id } = useParams();
  const [update, { isLoading: isUpdating }] = useUpdate();
  const [deleteOne, { isLoading: isDeleting }] = useDelete();
  const redirect = useRedirect();
  const notify = useNotify();

  const { data: estimate, isLoading: isLoadingEstimate } = useGetOne('estimates', { id: id! });

  const handleSave = async (data: Record<string, unknown>, action: 'draft' | 'send') => {
    try {
      await update('estimates', { id: id!, data });

      if (action === 'send') {
        notify('Estimate updated and sent successfully!', { type: 'success' });
      } else {
        notify('Estimate updated and saved as draft', { type: 'success' });
      }

      redirect('show', 'estimates', id!);
    } catch (error) {
      throw error; // Let EstimateBuilder handle the error notification
    }
  };

  const handleDelete = async () => {
    try {
      await deleteOne('estimates', { id: id! });
      notify('Estimate deleted successfully', { type: 'success' });
      redirect('list', 'estimates');
    } catch (error: any) {
      throw error; // Let EstimateBuilder handle the error notification
    }
  };

  if (isLoadingEstimate) {
    return <div>Loading...</div>;
  }

  return (
    <Edit title="Edit Estimate" redirect={false}>
      <EstimateBuilder
        estimate={estimate}
        onSave={handleSave}
        onDelete={handleDelete}
        isLoading={isUpdating || isDeleting}
      />
    </Edit>
  );
};
